import { render, staticRenderFns } from "./StudentsCard.vue?vue&type=template&id=d1e8ce18&"
import script from "./StudentsCard.vue?vue&type=script&lang=ts&"
export * from "./StudentsCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudentsCard.vue?vue&type=style&index=0&id=d1e8ce18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports